import { Content, Main } from '@atlaskit/page-layout';
import React, { PropsWithChildren } from 'react';
import { useRouter } from 'react-resource-router';

import { HomeSidebarNavigationWrapper } from '@townsquare/home-layout/home-sidebar';
import { IntroPopup } from '@townsquare/onboarding/intro-popup';
import { ResponsivePageWithSidebar, ResponsiveSection } from '@townsquare/responsive-grid';
import { useNoWorkspaceExperience } from '@townsquare/workspace-store';

const NO_SIDE_COLUMN_CUSTOM_WIDTH = 1296;

export function HomeLayout({ children }: PropsWithChildren<NonNullable<unknown>>) {
  const [routerState] = useRouter();
  const noWorkspaceExperience = useNoWorkspaceExperience();

  return (
    <Content>
      <Main>
        <ResponsivePageWithSidebar customWidth={NO_SIDE_COLUMN_CUSTOM_WIDTH}>
          <ResponsiveSection>
            <HomeSidebarNavigationWrapper {...routerState} isHome />
            {children}
          </ResponsiveSection>
        </ResponsivePageWithSidebar>
        {noWorkspaceExperience && <IntroPopup />}
      </Main>
    </Content>
  );
}
